export default __webpack_public_path__ + "locales/el-GR/DeleteDialog.json?hash=cc1e327d366601393a99a40a0e3d4ff3";